/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */
// Decodes a Base64Url string
const base64UrlDecode = (input) => {
	input = input.replace(/-/g, '+').replace(/_/g, '/');

	const pad = input.length % 4;
	if(pad) {
		if(pad === 1) { throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding') }
		input += new Array(5-pad).join('=');
	}

	return window.atob(input);
};

// Converts an array of bytes into a Base64Url string
const arrayToBase64String = (a) => btoa(String.fromCharCode(...a));

// Prepares the public key options object returned by the Webauthn Framework
export const preparePublicKeyOptions = publicKey => {
	//Convert challenge from Base64Url string to Uint8Array
	publicKey.challenge = Uint8Array.from(base64UrlDecode(publicKey.challenge),c => c.charCodeAt(0));

	//Convert the user ID from Base64 string to Uint8Array
	if(publicKey.user !== undefined) {
		publicKey.user = {
			...publicKey.user,
			id: Uint8Array.from(window.atob(publicKey.user.id),c => c.charCodeAt(0)),
		};
	}

	//If excludeCredentials is defined, we convert all IDs to Uint8Array
	if(publicKey.excludeCredentials !== undefined) {
		publicKey.excludeCredentials = publicKey.excludeCredentials.map(
			data => {
				return {
					...data,
					id: Uint8Array.from(base64UrlDecode(data.id),c => c.charCodeAt(0)),
				};
			}
		);
	}

	if(publicKey.allowCredentials !== undefined) {
		publicKey.allowCredentials = publicKey.allowCredentials.map(
			data => {
				return {
					...data,
					id: Uint8Array.from(base64UrlDecode(data.id),c => c.charCodeAt(0)),
				};
			}
		);
	}

	return publicKey;
};




// Convet the the public key credentials object returned from authenticator
// into a plain object, which is is json-encodeable for submission to server.
export const preparePublicKeyCredentials = publicKeyCredential => {

	// https://developer.mozilla.org/en-US/docs/Web/API/AuthenticatorAssertionResponse
	const assertionResponse = publicKeyCredential.response;

	const result = {
		id: publicKeyCredential.id,
		type: publicKeyCredential.type,
		rawId: arrayToBase64String(new Uint8Array(publicKeyCredential.rawId)),
		response: {
			clientDataJSON: arrayToBase64String(new Uint8Array(assertionResponse.clientDataJSON)),
		},
	};

	if(assertionResponse.attestationObject !== undefined) {
		result.response.attestationObject = arrayToBase64String(new Uint8Array(assertionResponse.attestationObject));
	}

	if(assertionResponse.authenticatorData !== undefined) {
		result.response.authenticatorData = arrayToBase64String(new Uint8Array(assertionResponse.authenticatorData));
	}

	if(assertionResponse.signature !== undefined) {
		result.response.signature = arrayToBase64String(new Uint8Array(assertionResponse.signature));
	}

	if(assertionResponse.userHandle !== undefined) {
		result.response.userHandle = arrayToBase64String(new Uint8Array(assertionResponse.userHandle));
	}

	return result;
};
